import {makeTextField, makeEmailField} from 'utils/form/fieldTypes'
import {makeFormSchema} from 'utils/form/schema'

export const getMedicaidLoginFormSchema = () =>
  makeFormSchema({
    fields: {
      credentials: {
        email: makeEmailField({
          isRequired: true,
        }),
        password: makeTextField({
          isRequired: true,
        }),
      },
    },
  })

export const staticMedicaidLoginFormSchema = getMedicaidLoginFormSchema()
